/**
 * Responsive Background Module
 * Podmienia background-image na wersję mobile/desktop
 * w oparciu o atrybut data-bg-mobile.
 *
 * Użycie:
 *   <article style="background-image: url('desktop.jpg')"
 *            data-bg-mobile="mobile.jpg">
 *
 * Na mobile (<1024px) ustawia background-image z data-bg-mobile.
 * Na desktop (>=1024px) przywraca oryginalny inline style.
 */

(function () {
    'use strict';

    var BREAKPOINT = 1024; // $breakpoint-lg
    var SELECTOR = '[data-bg-mobile]';

    function init() {
        var elements = document.querySelectorAll(SELECTOR);
        if (!elements.length) return;

        // Zapisz oryginalne (desktopowe) tła
        elements.forEach(function (el) {
            el.setAttribute('data-bg-desktop', el.style.backgroundImage);
        });

        function update() {
            var isMobile = window.innerWidth < BREAKPOINT;

            elements.forEach(function (el) {
                if (isMobile) {
                    var mobileSrc = el.getAttribute('data-bg-mobile');
                    el.style.backgroundImage = "url('" + mobileSrc + "')";
                } else {
                    var desktopSrc = el.getAttribute('data-bg-desktop');
                    el.style.backgroundImage = desktopSrc;
                }
            });
        }

        // Uruchom na starcie
        update();

        // Nasłuchuj na resize (debounced)
        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(update, 150);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
